import type {ISceneManager} from "#template/interfaces/scene-manager"
import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"
import type {NodeClassImpl} from "#template/runtime-graph/types"
import type {DataObjectWithRelated} from "@cm/utils"
import type {Subscription} from "rxjs"
import {defer, map} from "rxjs"

const TD = TypeDescriptors

const fetchDataObjectDescriptor = {
    sceneManager: TD.inlet(TD.Identity<ISceneManager>()),
    dataObjectId: TD.inlet(TD.Number),
    dataObject: TD.outlet(TD.DataObject),
}

export class FetchDataObject implements NodeClassImpl<typeof fetchDataObjectDescriptor, typeof FetchDataObject> {
    static descriptor = fetchDataObjectDescriptor
    static uniqueName = "FetchDataObject"
    sceneManager!: Inlet<ISceneManager>
    dataObjectId!: Inlet<number>
    dataObject!: Outlet<DataObjectWithRelated>

    private pending: Subscription | null = null

    run() {
        this.cleanup()

        if (this.sceneManager === NotReady || this.dataObjectId === NotReady) {
            this.dataObject.emitIfChanged(NotReady)
            return
        }

        const {sceneManager, dataObjectId} = this

        this.pending = this.sceneManager.addTask({
            description: `loadDataObject(${this.dataObjectId})`,
            task: defer(() => sceneManager.getResolver().dataObjectLegacy(dataObjectId)).pipe(
                map((dataObject) => {
                    this.dataObject.emitIfChanged(dataObject)
                }),
            ),
            critical: true,
        })
    }

    cleanup() {
        this.pending?.unsubscribe()
        this.pending = null
    }
}
